import { Mail, Phone, MapPin, Send } from 'lucide-react'

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-grid">
          <div className="contact-info">
            <span className="section-tag">Get In Touch</span>
            <h2 className="section-title">Ready to Start Your Project?</h2>
            <p className="contact-description">
              Let's discuss how we can help bring your ideas to life. Reach out 
              and we'll get back to you within 24 hours.
            </p>
            <div className="contact-methods">
              <div className="contact-method">
                <Mail size={24} />
                <div>
                  <span className="method-label">Email</span>
                  <span className="method-value">hello@yourservices.com</span>
                </div>
              </div>
              <div className="contact-method">
                <Phone size={24} />
                <div>
                  <span className="method-label">Phone</span>
                  <span className="method-value">+1 (555) 123-4567</span>
                </div>
              </div>
              <div className="contact-method">
                <MapPin size={24} />
                <div>
                  <span className="method-label">Location</span>
                  <span className="method-value">123 Innovation Street, Tech City</span>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-form-wrapper">
            <form className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input type="text" id="name" placeholder="Your name" />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input type="email" id="email" placeholder="your@email.com" />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="subject" placeholder="Project inquiry" />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" rows={5} placeholder="Tell us about your project..."></textarea>
              </div>
              <button type="submit" className="btn btn-primary btn-full">
                <Send size={18} />
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
